import index from './index';
import page from './page';
import { Router } from '@/legacy/Router';

Router.get('/', index);
Router.get('/#:any', index);
Router.get('/page/:any', page);
